const type = 'SET_BANK_ACCOUNT_SEARCH_BY_ID_RESULTS';

const setBankAccountSearchByIdResults = (value) => ({
  value,
  type,
});

export { type };
export default setBankAccountSearchByIdResults;
